import React from "react";
import {
  InputContainer,
  Label,
  StyledInput,
  ErrorText,
} from "./InputField.styled";

const InputField = ({
  label,
  id,
  error,
  errorMessage,
  required,
  fullWidth,
  name,
  autoComplete = "off", // Changed default to "off"
  inputProps,
  ...props
}) => {
  return (
    <InputContainer fullWidth={fullWidth}>
      {label && (
        <Label>
          {label}
          {required && <span className="required"> *</span>}
        </Label>
      )}
      <StyledInput
        id={id || `input_${Math.random().toString(36).substr(2, 9)}`} // randomized ID if not provided
        name={name || `input_${Math.random().toString(36).substr(2, 9)}`} // random obfuscated name
        error={error}
        required={required}
        variant="outlined"
        fullWidth
        autoComplete={autoComplete}
        inputProps={{
          autoComplete: "off", // Add autoComplete at input level
          ...inputProps,
        }}
        {...props}
      />
    </InputContainer>
  );
};

export default InputField;
